export enum ELinkType {
  LINK_TO = 'link-to',
  BE_LINKED = 'be-linked',
}

export enum ENumberType {
  INCREASE = 'increase',
  DECREASE = 'decrease',
}

export enum ECustomFieldType {
  TEXT = 'text',
  DATE = 'date',
  DATE_TIME_DATA = 'dateTimeData',
  SINGLE_SELECT = 'singleSelect',
  MULTI_SELECT = 'multiSelect',
  NUMBER = 'number',
  ESIGN = 'eSign',
  FILES = 'files',
  EMAIL = 'email',
  PHONE_NUMBER = 'phoneNumber',
  LOCATION = 'location',
  REFERENCE = 'reference',
  GHG_EMISSION = 'ghgEmission',
  CALCULATION = 'calculation',
  WEIGHT_MEASUREMENT = 'weightMeasurement',
  ADJUSTMENT = 'adjustment',
  LIST_STRING = 'listString',
}

export const AVAILABLE_DELIMITERS = ['.', ';', ':', '::', '/', '-', '_', '!', 'space'] as const

export enum ECustomButtonFormBuilderType {
  BUTTON = 'el-button',
  RADIO = 'el-radio-group',
}

export const enum EDisplaySetting {
  VISIBLE = 'visible',
  VISIBLE_WHEN_LOGGED_IN = 'visibleWhenLoggedIn',
  HIDDEN = 'hidden',
  UNKNOWN = 'unknown',
}

export const enum ECustomFieldUnitPosition {
  DEFAULT = '',
  UNKNOWN = 'unknown',
  PREFIX = 'prefix',
  SUFFIX = 'suffix',
}

export enum EFileKind {
  IMAGE = 'image',
  UNKNOWN = 'unknown',
  BARCODE_SCAN_FRAME = 'barcodeScanFrame',
  PHOTO_ONLY = 'photoOnly',
}

export enum EUserType {
  ENTERPRISE = 'enterprise',
  CARRIER = 'carrier',
  CLIENT = 'client',
}

export enum EValidationType {
  digitOnly = 'digitOnly',
  digitDashOnly = 'digitDashOnly',
  digitUnderscoreOnly = 'digitUnderscoreOnly',
  letterOnly = 'letterOnly',
  letterDashOnly = 'letterDashOnly',
  letterUnderscoreOnly = 'letterUnderscoreOnly',
  letterDigitOnly = 'letterDigitOnly',
  letterDigitDashOnly = 'letterDigitDashOnly',
  letterDigitUnderscoreOnly = 'letterDigitUnderscoreOnly',
  none = 'none',
}

export enum EParseType {
  LENGTH = 'length',
  DELIMITER = 'delimiter',
  REGEX = 'regex',
}

export enum EActivatedDateOptions {
  Dynamic = 'dynamicDate',
  Static = 'staticDate',
}

export enum ValueDateOptions {
  Today = 'today',
  ThisWeek = 'thisWeek',
  ThisMonth = 'thisMonth',
  ThisYear = 'thisYear',
}

export enum EOCRReaderType {
  UNKNOWN = 'unknown',
  DEFAULT = 'default',
}

export enum EReaderType {
  UNKNOWN = 'unknown',
  DEFAULT = 'default',
  SCANDIT = 'scandit',
}

export enum ELinkedBarcodeHrefType {
  SNAPSHOT = 'snapshot',
  LATEST = 'latest',
}

export enum EEventType {
  ACTIVATING = 'activating',
  TRACKING = 'tracking',
}

export enum ENotificationtiming {
  BEFORE = 'before',
  AFTER = 'after',
  AT_THE_TIME = 'atTheTime',
}

export enum EBCRType {
  UNKNOWN = 'unknown',
  DEFAULT = 'default',
  SCANDIT = 'scandit',
  BARCODE_DETECTION = 'barcodeDetector',
}

export enum EOCRType {
  UNKNOWN = 'unknown',
  DEFAULT = 'default',
}

export enum ECameraReaderType {
  OCR = 'ocr',
  BCR = 'barcode_reader',
}

export const enum EBCTypeIconKey {
  NODE = 'node',
  LEAF = 'leaf',
  ORPHAN = 'orphan',
  VACCINE = 'vaccine',
  TRUCK = 'truck',
  CONTAINER = 'container',
  TIMETABLE = 'timetable',
  INVENTORY = 'inventory',
  WAREHOUSE = 'warehouse',
  RACK = 'rack',
  FORKLIFT = 'forklift',
  PACKAGES = 'packages',
  PACKAGE = 'package',
  PAPER = 'paper',
  PERSON = 'person',
  TRAIN = 'train',
  SHIP = 'ship',
  AIRPLANE = 'airplane',
}

export const enum EPackageInfoKey {
  TRACKING_NUMBER = 'trackingNumber',
  EXTERNAL_ID = 'externalId',
  DIMENSION = 'dimension',
  WIDTH = 'width',
  WEIGHT = 'weight',
  HEIGHT = 'height',
  DEPTH = 'depth',
}

// Barcode reader catetory
export const enum EBCReaderCategory {
  QR = 'QR',
  ONE_DIMENSION = '1D',
  DEFAULT = 'Default',
}

export const enum EStockOperationType {
  INSTOCK = 'inStock',
  OUTSTOCK = 'outStock',
}

export const enum EOperatorType {
  ADD = 'add',
  USE = 'use',
  CORRECT_VALUE = 'correctValue',
  UNKNOWN = 'unknown',
}
